import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth.guard';


import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { LoginLayoutComponent } from '../app/Shared/loginlayout/loginlayout.component';
import { HomeLayoutComponent } from '../app/Shared/homelayout/homelayout.component';
import { UserComponent } from './Master/user/user.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { LogoutComponent } from './logout/logout.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { GovernmentComponent } from './Master/government/government.component';
import { OpiniontypeComponent } from './Master/opiniontype/opiniontype.component';
import { PartComponent } from './Master/part/part.component';
import { StateComponent } from './Master/state/state.component';
import { CourtComponent } from './Master/court/court.component';
import { OutputformatComponent } from './Master/outputformat/outputformat.component';
import { DepartmentComponent } from './Master/department/department.component';
import { BranchComponent } from './Master/branch/branch.component';
import { BusinessunitComponent } from './Master/businessunit/businessunit.component';
import { DocumenttitleComponent } from './Master/documenttitle/documenttitle.component';
import { DtdComponent } from './Master/dtd/dtd.component';
import { ConversiontypeComponent } from './Master/conversiontype/conversiontype.component';
import { MastermgtComponent } from './Master/mastermgt/mastermgt.component';
import { DocumenttypeComponent } from './Master/documenttype/documenttype.component';
import { AgencyComponent } from './Master/agency/agency.component';
import { DatabaseComponent } from './Master/database/database.component';
import { ProductComponent } from './Master/product/product.component';
import { MailfieldsComponent } from './Master/mailfields/mailfields.component';
import { MailtemplateComponent } from './Template/mailtemplate/mailtemplate.component';
import { MailgroupComponent } from './mailgroup/mailgroup.component';
import { AccessrequestComponent } from './accessrequest/accessrequest.component';
import { UsermgtComponent } from './usermgt/usermgt.component';
import { AccessrightsadminComponent } from './accessrightsadmin/accessrightsadmin.component';
import { TeammgtComponent } from './teammgt/teammgt.component';
import { UseraddComponent } from './Master/useradd/useradd.component';
import { DatabasemgmtComponent } from './databasemgmt/databasemgmt.component';
import { FormtemplateComponent } from './Template/formtemplate/formtemplate.component';
import { FormconfigComponent } from './configuration/formconfig/formconfig.component';
import { RequestconfigComponent } from './configuration/requestconfig/requestconfig.component';
import { ReleasenotesComponent } from './Shared/releasenotes/releasenotes.component';
import { MailconfigComponent } from './configuration/mailconfig/mailconfig.component';
import { StatusinputComponent } from './Master/statusinput/statusinput.component';
import { AllocationComponent } from './Master/allocation/allocation.component';
import { FormrenderComponent } from './formrender/formrender.component';
import { RequestdashboardComponent } from './dashboard/requestdashboard/requestdashboard.component';
import { CostcenterComponent } from './Master/costcenter/costcenter.component';
import { ProductgroupComponent } from './Master/productgroup/productgroup.component';
import { TypeComponent } from './Master/type/type.component';
import { FormdashboardComponent } from './dashboard/formdashboard/formdashboard.component';
import { QuerycommentsComponent } from './Shared/querycomments/querycomments.component';
import { QuerycommentsmgtComponent } from './querycommentsmgt/querycommentsmgt.component';
import { RecentactivitiesdashboardComponent } from './dashboard/recentactivitiesdashboard/recentactivitiesdashboard.component';
import { ArbitrationComponent } from './arbitration/arbitration.component';
import { ViewarbitrationComponent } from './arbitration/viewarbitration/viewarbitration.component';
import { ActivitylogComponent } from './activitylog/activitylog.component';

import { FiledownloadComponent } from './Shared/filedownload/filedownload.component';
import { DocumenttypegeneraluseComponent } from './Master/documenttypegeneraluse/documenttypegeneraluse.component';
import { DocumenttypefederalregisteritemsComponent } from './Master/documenttypefederalregisteritems/documenttypefederalregisteritems.component';
import { DocumenttypeinternalrevenuebulletinsComponent } from './Master/documenttypeinternalrevenuebulletins/documenttypeinternalrevenuebulletins.component';
import { DocumenttypeletterrullingComponent } from './Master/documenttypeletterrulling/documenttypeletterrulling.component';
import { DatabasearchiveComponent } from './databasearchive/databasearchive.component';
import { CourtnameComponent } from './Master/courtname/courtname.component';
import { OpinionreviewComponent } from './Report/opinionreview/opinionreview.component';
import { ArchivedashboardComponent } from './dashboard/archivedashboard/archivedashboard.component';
import { PrehomepageComponent } from './prehomepage/prehomepage.component';
import { CbadashboardComponent } from    './dashboard/cbadashboard/cbadashboard.component';
const appRoutes: Routes = [

  //Site routes goes here 
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      { path: '', component: LoginComponent, pathMatch: 'full' },
      { path: 'archive', component: ArbitrationComponent },
      { path: 'archive/viewarbitration', component: ViewarbitrationComponent },
      { path: 'accessrequest', component: AccessrequestComponent },
      { path: 'resetpassword', component: ResetpasswordComponent }

    ]
  },

  // App routes goes here here
  {
    path: '',
    component: HomeLayoutComponent,
    children: [
      { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
    //  { path: 'homepage', component: PrehomepageComponent, canActivate: [AuthGuard] },
      { path: 'changepassword', component: ChangepasswordComponent, canActivate: [AuthGuard] },
     // { path: 'releasenotes', component: ReleasenotesComponent, canActivate: [AuthGuard] },
      { path: 'home/team', component: TeammgtComponent, canActivate: [AuthGuard] },
      { path: 'home/useradd', component: UseraddComponent, canActivate: [AuthGuard] },
      { path: 'home/formconfig', component: FormconfigComponent, canActivate: [AuthGuard] },
      { path: 'home/mailconfig', component: MailconfigComponent, canActivate: [AuthGuard] },
      { path: 'home/requestconfig', component: RequestconfigComponent, canActivate: [AuthGuard] },
      { path: 'home/formrender', component: FormrenderComponent, canActivate: [AuthGuard] },
      { path: 'home/requestdashboard', component: RequestdashboardComponent, canActivate: [AuthGuard] },
      { path: 'home/formdashboard', component: FormdashboardComponent, canActivate: [AuthGuard] },
      { path: 'home/cbadashboard', component: CbadashboardComponent, canActivate: [AuthGuard] },
      { path: 'home/querycomments', component: QuerycommentsComponent, canActivate: [AuthGuard] },
      { path: 'home/querycommentsmgt', component: QuerycommentsmgtComponent, canActivate: [AuthGuard] },
      { path: 'home/recentactivities', component: RecentactivitiesdashboardComponent, canActivate: [AuthGuard] },
      { path: 'home/activitylog', component: ActivitylogComponent, canActivate: [AuthGuard] },
     { path: 'home/dbarchive', component: DatabasearchiveComponent, canActivate: [AuthGuard]},
     
      {
        path: 'home/usermgt', component: UsermgtComponent, canActivate: [AuthGuard],
        children: [
          { path: '', redirectTo: 'user', pathMatch: 'full' },
          {
            path: 'user', component: UserComponent, canActivate: [AuthGuard]
          },
          { path: 'useradd', component: UseraddComponent, canActivate: [AuthGuard] },
          { path: 'accessrightsadmin', component: AccessrightsadminComponent, canActivate: [AuthGuard] }
        ]
      },

      { path: 'home/useradd', component: UseraddComponent, canActivate: [AuthGuard] },
      {
        path: 'home/mailtemplate', component: MailtemplateComponent, canActivate: [AuthGuard]
      },
      {
        path: 'home/formtemplate', component: FormtemplateComponent, canActivate: [AuthGuard]
      },
      {
        path: 'home/mastermgt', component: MastermgtComponent, canActivate: [AuthGuard],
        children: [
          { path: 'allocation', component: AllocationComponent, canActivate: [AuthGuard] },
          { path: 'statusinput', component: StatusinputComponent, canActivate: [AuthGuard] },
          { path: 'department', component: DepartmentComponent, canActivate: [AuthGuard]},
          { path: 'database', component: DatabaseComponent, canActivate: [AuthGuard]},
          { path: 'court', component: CourtComponent, canActivate: [AuthGuard]},
          { path: 'branch', component: BranchComponent, canActivate: [AuthGuard] },
          { path: 'businessunit', component: BusinessunitComponent, canActivate: [AuthGuard] },
          { path: 'documenttitle', component: DocumenttitleComponent, canActivate: [AuthGuard] },
          { path: 'documenttype', component: DocumenttypeComponent, canActivate: [AuthGuard] },

          { path: 'documenttypegeneraluse', component: DocumenttypegeneraluseComponent, canActivate: [AuthGuard] },
          { path: 'documenttypefederalregisteritems', component: DocumenttypefederalregisteritemsComponent, canActivate: [AuthGuard] },
          { path: 'documenttypeinternalrevenuebulletins', component: DocumenttypeinternalrevenuebulletinsComponent, canActivate: [AuthGuard] },
          { path: 'documenttypeletterrulling', component: DocumenttypeletterrullingComponent, canActivate: [AuthGuard] },

          { path: 'dtd', component: DtdComponent, canActivate: [AuthGuard] },
          { path: 'conversiontype', component: ConversiontypeComponent, canActivate: [AuthGuard] },
          { path: 'government', component: GovernmentComponent, canActivate: [AuthGuard] },
          { path: 'agency', component: AgencyComponent, canActivate: [AuthGuard]},
          { path: 'opiniontype', component: OpiniontypeComponent, canActivate: [AuthGuard] },
          { path: 'part', component: PartComponent, canActivate: [AuthGuard] },
          { path: 'state', component: StateComponent, canActivate: [AuthGuard] },
          { path: 'product', component: ProductComponent, canActivate: [AuthGuard] },
          { path: 'mailfields', component: MailfieldsComponent, canActivate: [AuthGuard] },
          { path: 'outputformat', component: OutputformatComponent, canActivate: [AuthGuard] },
          { path: 'costcenter', component: CostcenterComponent, canActivate: [AuthGuard] },
          { path: 'productgroup', component: ProductgroupComponent, canActivate: [AuthGuard] },
          { path: 'type', component: TypeComponent, canActivate: [AuthGuard] },
        ]

      },
      { path: 'home/mailgroup', component: MailgroupComponent, canActivate: [AuthGuard] },
      { path: 'home/databasemgt', component: DatabasemgmtComponent, canActivate: [AuthGuard] },
      { path: 'home/courtname', component: CourtnameComponent, canActivate: [AuthGuard] } ,     
      { path: 'home/opinionreview', component: OpinionreviewComponent },
      { path: 'home/archivedashboard', component: ArchivedashboardComponent }
     
    ] //, canActivate: [AuthGuard]
  },
  { path: 'logout', component: LogoutComponent },
  { path: 'filedownload', component: FiledownloadComponent } ,
  { path: 'homepage', component: PrehomepageComponent },
  { path: 'arbitration', component: ArbitrationComponent },
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

export const routing = RouterModule.forRoot(appRoutes);
